import { Observable, throwError } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { catchError } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);

    constructor() {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the single seesion  header from the service.
        const singleSessionHeader = this.addSingleSessionHeader(req.headers);
        // Clone the request to add the new header.
        if (singleSessionHeader && req.headers.keys().indexOf("x-prevent-authorization-header") === -1) {
            const authReq = req.clone({ headers: singleSessionHeader });
            return next.handle(authReq).pipe(
                catchError((err) => {
                    if (this.authService.loggedIn()) {
                        // TODO: If 401, return to login screen, set error messages here
                        // authService.logout(true);
                    }
                    return throwError(() => err);
                }),
            );
        }
        if (req.headers.keys().indexOf("x-prevent-authorization-header") > -1) {
            req = req.clone({ headers: req.headers.delete("x-prevent-authorization-header") });
        }
        return next.handle(req).pipe(
            catchError((err) => {
                return throwError(() => err);
            }),
        );
        // Pass on the cloned request instead of the original request.
    }

    addSingleSessionHeader(headers: HttpHeaders) {
        return this.authService.addSingleSessionHeader(headers);
    }
}
